import { Link, Outlet, useLoaderData, useLocation, useSearchParams } from "react-router-dom";

import ServerFooter from "../common/ServerFooter";
import { Service } from "./types";

export const extraFields = ["page", "limit"];

export default function ServiceList() {
    const [searchParams] = useSearchParams();
    const { services, total }: { services: Service[]; total: number } = useLoaderData() as { services: Service[]; total: number };
    const location = useLocation();
    const onFilter = [...searchParams.keys()].filter(param => !extraFields.includes(param)).length > 0;

    return (
        <div className = "cssContent pb8rem">
            <div className = "mt-2">
                <Link className = "btn btn-outline-primary pointer position-relative" to = {{ pathname: "Filter", search: location.search }} replace>
                    Filter
                    {onFilter ? <span className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle" style = {{ minWidth: "2.4em" }}>on</span> : null}
                </Link>
                <Link className = "btn btn-outline-primary pointer ms-3" to = {{ pathname: "Export", search: location.search }}>
                    Export
                </Link>
                <Link className = "btn btn-outline-primary float-end" to = "Add">
                    Add
                </Link>
            </div>
            {!services.length ? (
                <div className = "cssLoading">Empty</div>
            ) : (
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th>ID</th>
                                <th>Code</th>
                                <th>Name</th>
                                <th>Category</th>
                                <th>Price</th>
                                <th>Cost Type</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {services.map((service, key) => (
                                <tr key = {key}>
                                    <td>{service.id}</td>
                                    <td>{service.code}</td>
                                    <td>{service.name}</td>
                                    <td>{service.category}</td>
                                    <td>{service.price}</td>
                                    <td>{service.costType}</td>
                                    <td><Link className = "btn btn-outline-primary" to = {String(service.id)}>Detail</Link></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {total > 0 ? <ServerFooter length = {total} /> : null}
            <Outlet />
        </div>
    );
}
